import type { ReactNode } from 'react';
import React from 'react';

import { ROOT } from '../data-hooks';
import styles from '../statics/styles/image-viewer.rtlignore-scss';
import type { ImageClickActionConfig } from './common-types';

type ImageContainerProps = ImageClickActionConfig & {
  disableDownload: boolean | undefined;
  children: ReactNode;
};

export const ImageContainer = (props: ImageContainerProps) => {
  const { type, children } = props;

  const onContextMenu =
    props.disableDownload === true ? (e: React.MouseEvent) => e.preventDefault() : undefined;

  const hasOnClick = 'onClick' in props;

  const onClick = hasOnClick ? props.onClick : undefined;

  const onKeyDown = onClick
    ? (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(e);
        }
      }
    : undefined;

  const interactions = {
    onClick,
    onKeyDown,
    onContextMenu,
  };

  const role =
    hasOnClick || ((type === 'anchor' || type === 'link' || type === 'regular') && !!onContextMenu)
      ? 'button'
      : undefined;

  return (
    <div
      {...(role === 'button' ? interactions : {})}
      data-hook={ROOT}
      className={styles.imageContainer}
    >
      {children}
    </div>
  );
};
